// @ts-nocheck
import { isRef, ref } from 'vue'
import { hyphenate, isObject, isString } from '@vue/shared'
import { LoadingService } from './service'
import type { Directive, DirectiveBinding, UnwrapRef } from 'vue'
import type { LoadingOptions } from './types'
import type { LoadingInstance } from './createLoading'

const INSTANCE_KEY = Symbol('SgLoading')

export type LoadingBinding = boolean | UnwrapRef<LoadingOptions>
export interface SgLoading extends HTMLElement {
  [INSTANCE_KEY]?: {
    instance: LoadingInstance
    options: LoadingOptions
  }
}

const createInstance = (
  el: SgLoading,
  binding: DirectiveBinding<LoadingBinding>
) => {
  const vm = binding.instance

  const getBindingProp = <K extends keyof LoadingOptions>(
    key: K
  ): LoadingOptions[K] =>
    isObject(binding.value) ? binding.value[key] : undefined

  const resolveExpression = (key: any) => {
    const data = (isString(key) && vm?.[key]) || key
    if (data) return ref(data)
    else return data
  }

  const getProp = <K extends keyof LoadingOptions>(name: K) =>
    resolveExpression(
      getBindingProp(name) ||
        el.getAttribute(`loading-${hyphenate(name)}`)
    )

  const fullscreen =
    getBindingProp('fullscreen') ?? binding.modifiers.fullscreen
  const name = 'backgroundColor'
  // console.log(getBindingProp(name) || el.getAttribute(`loading-${hyphenate(name)}`), hyphenate(name))

  const options: LoadingOptions = {
    text: getProp('text'),
    fix: getProp('fix'),
    spinner: getProp('spinner'),
    color: getProp('color'),
    backgroundColor: getProp('backgroundColor'),
    customClass: getProp('customClass'),
    fullscreen,
    parent: getBindingProp('parent') ?? (fullscreen ? undefined : el),
    transfer: getBindingProp('transfer') ?? binding.modifiers.transfer,
    lock: getBindingProp('lock') ?? binding.modifiers.lock,
  }

  // console.log('LoadingOptions', options)

  el[INSTANCE_KEY] = {
    options,
    instance: LoadingService(options),
  }
}

const updateOptions = (
  newOptions: UnwrapRef<LoadingOptions>,
  originalOptions: LoadingOptions
) => {
  for (const key of Object.keys(originalOptions)) {
    if (isRef(originalOptions[key]))
      originalOptions[key].value = newOptions[key]
  }
}

export const vLoading: Directive<SgLoading, LoadingBinding> = {
  mounted(el, binding) {
    if (binding.value) {
      createInstance(el, binding)
    }
  },
  updated(el, binding) {
    const instance = el[INSTANCE_KEY]
    if (binding.oldValue !== binding.value) {
      if (binding.value && !binding.oldValue) {
        createInstance(el, binding)
      } else if (binding.value && binding.oldValue) {
        if (isObject(binding.value))
          updateOptions(binding.value, instance!.options)
      } else {
        instance?.instance.close()
      }
    }
  },
  unmounted(el) {
    el[INSTANCE_KEY]?.instance.close()
  },
}
